
import {
  computed,
  defineComponent, onMounted, ref, Ref,
} from 'vue';
import { useRouter } from 'vue-router';
import AppLoader from '@/components/UI/AppLoader.vue';
import RegistrationDoctorCard from '@/modules/registration/components/RegistrationDoctorCard.vue';
import AppButton from '@/components/UI/AppButton.vue';
import { IDoctor, IUserSearchData } from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import RegistrationService from '@/modules/registration/services/RegistrationService';
import { useRegistrationStore } from '../store/registrationStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';
import { HEALTHCARE } from '@/types/enums';

export type TSelectedUser = null | number;

export default defineComponent({
  components: {
    AppLoader,
    AppButton,
    RegistrationDoctorCard,
  },
  setup() {
    const router = useRouter();
    const registrationStore = useRegistrationStore();

    const dataRequest: Ref<boolean> = ref(false);
    const doctor: Ref<IDoctor | undefined> = ref(undefined);

    const skipNpiUrl = computed(() => {
      const { profession } = registrationStore.createUser;
      if (profession === HEALTHCARE.OTHER) {
        return 'step-3a';
      }
      if (profession === HEALTHCARE.NURSING) {
        return 'step-3b';
      }
      if (profession === HEALTHCARE.ALLIED_HEALTH) {
        return 'step-3c';
      }
      if (profession === HEALTHCARE.DENTAL) {
        return 'step-3d';
      }
      if (profession === HEALTHCARE.MEDICAL) {
        return 'step-3e';
      }
      return 'step-7';
    });

    function getUserData() {
      dataRequest.value = true;

      const playload: IUserSearchData = {
        firstName: '',
        lastName: '',
        npi: registrationStore.searchUser.npi,
      };
      RegistrationService.getDoctorsData(playload)
        .then((response) => {
          if (response.success) {
            if (!response.results.data.length) {
              router.replace('step-4e');
            }
            // eslint-disable-next-line prefer-destructuring
            doctor.value = response.results.data[0];
          }
        })
        .catch(() => { router.replace('step-4e'); })
        .finally(() => { dataRequest.value = false; });
    }

    // function resolveState(location: string): string {
    //   const tempLocation = location.split(' ');
    //   tempLocation.shift();
    //   return tempLocation.join(' ');
    // }

    function nextStep() {
      if (doctor.value) {
        registrationStore.$patch({
          createUser: { npi: doctor.value.npi, state: doctor.value.location },
        });
      }

      router.push('step-5');
    }

    onMounted(() => {
      if (registrationStore.searchUser.npi) {
        getUserData();
      } else {
        router.push('step-4a');
      }
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      dataRequest,
      doctor,
      skipNpiUrl,
      nextStep,
    };
  },
});
